import React, { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { Button } from "@components/ui/button";
import { Input } from "@components/ui/input";
import { IoAdd } from "react-icons/io5";
import { Eye, EyeOff } from "lucide-react"; // Import the icons
import { addEmailAccount, getEmailAccountById, updateEmailAccount } from "@redux/slices/email";
import useAuth from "@hooks/useAuth";
import { z } from "zod";
import * as Select from "@radix-ui/react-select";
import {
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@components/ui/select";
import { ChevronLeft } from "lucide-react";
import { useNavigate } from "react-router";
import LoadingScreen from "@components/LoadingScreen";
import { EmailAccount } from "@redux/slices/email";

const EditEmailAccount: React.FC = () => {
  const [loading, setLoading] = useState(false);
  // const [account, setAccount] = useState();
  const { user } = useAuth();
  const [account, setAccount] = useState<EmailAccount | undefined>(undefined);


  const navigate = useNavigate();

  const [showPassword, setShowPassword] = useState(false); // New state for password visibility

  // 
  // 
  // asdajdlajdlaskdjl
  const getData = async () => {
    const accountsData = await getEmailAccountById(user.id);
    const data = accountsData;
    console.log("i AM ENDED")
    reset(data && data[0] ? data[0] : undefined);
    setTimeout(() => {
      setLoading(false);
    }, 500);
  };

  useEffect(() => {
    setLoading(true);
    getData();
    setLoading(false);
  }, []);

  const emailAccountSchema = z.object({
    email: z
      .string()
      .min(1, "Email is required")
      .email("Invalid email address"),
    password: z.string().min(6, "Password must be at least 6 characters long"),
    server: z.string().nonempty("Server is required"),
    profile_type: z.string().nonempty("Profile type is required"),
  });

  type EmailAccountFormValues = z.infer<typeof emailAccountSchema>;

  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
    reset,
  } = useForm<EmailAccountFormValues>({
    resolver: zodResolver(emailAccountSchema),
  });

  const onSubmit = (data: EmailAccountFormValues) => {
    const accountData = {
      ...data,
    };
    updateEmailAccount(Number(window.location.pathname.split("/")[3]), accountData);
    reset();
    getData();
    navigate(-1);
  };
 


  return (
    <div>
      {loading ? (
        <LoadingScreen />
      ) : (
        <div className="bg-white p-8">
          <h4 className="text-xl font-bold flex items-center -ms-8 mb-5">
            <ChevronLeft
              size={22}
              className="me-3 cursor-pointer"
              onClick={() => navigate(-1)}
            />
            Edit Email Account
          </h4>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div>
              <p className="text-[#71717A] text-sm mb-1">Email Address</p>
              <Input {...register("email")}  placeholder={account?.email}/>
              {errors.email && (
                <span className="text-red-600 text-sm">
                  {errors.email.message}
                </span>
              )}
            </div>

            <div className="mt-4 relative ">
              <p className="text-[#71717A] text-sm mb-1">Password</p>
              <Input
                {...register("password")}
                type={showPassword ? "text" : "password"} // Toggle input type
              />
              <div
                className="absolute inset-y-8 right-0 pr-3 flex  cursor-pointer"
                onClick={() => setShowPassword(!showPassword)} // Toggle visibility
              >
                {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
              </div>
              {errors.password && (
                <span className="text-red-600 text-sm">
                  {errors.password.message}
                </span>
              )}
            </div>

            <div className="mt-4">
              <p className="text-[#71717A] text-sm mb-1">Profile Type</p>

              <Controller
                name="profile_type"
                control={control}
                defaultValue=""
                render={({ field }) => (
                  <Select.Root onValueChange={field.onChange} value={field.value || "working"}>
                    <SelectTrigger className="SelectTrigger bg-white border-none">
                      <SelectValue placeholder="Select Profile Type" />
                    </SelectTrigger>
                    <SelectContent className="SelectContent">
                      <SelectItem value="main">Main Profile</SelectItem>
                      <SelectItem value="working">Working Profile</SelectItem>
                    </SelectContent>
                  </Select.Root>
                )}
              />
              {errors.profile_type && (
                <span className="text-red-600 text-sm">
                  {errors.profile_type.message}
                </span>
              )}
            </div>

            <div className="mt-4">
              <p className="text-[#71717A] text-sm mb-1">Email Server</p>
              <Input {...register("server")} />
              {errors.server && (
                <span className="text-red-600 text-sm">
                  {errors.server.message}
                </span>
              )}
            </div>

            <Button className="mt-4" type="submit">
              Update
            </Button>
          </form>
        </div>
      )}
    </div>
  );
};

export default EditEmailAccount;
